import { useQuery, UseQueryOptions } from 'react-query';
import { StatusesService } from '../../services';
import { IStatus } from '../../interfaces';

export const useStatusById = (id?: string, options?: UseQueryOptions<IStatus, Error, IStatus, string[]>) => {
  return useQuery<IStatus, Error, IStatus, string[]>(
    ['status', id || ''],
    async ({ queryKey }) => {
      const [, statusId] = queryKey;
      const result = await StatusesService.getById(statusId);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    // cacheTime: 0 so reopening an edited row never seeds Formik from a stale pre-edit row.
    { cacheTime: 0, ...options },
  );
};
